import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import LoginModal from '../../components/Login/LoginModal';
import { closeModal } from '../actions/modalAction';
import {
  requestLogin,
  closeAuthModal,
  clearError,
  registerAccount,
  openSignUpModal,
  openLoginModal,
} from '../actions/authActions';

const mapStateToProps = ({ user }) => ({
  login: user.isModalOpen,
  isSignUp: user.isSignUpOpen,
  serverError: user.error,
  loading: user.isFetching,
});

const mapActionToProps = dispatch => ({
  requestLogin: credentials => dispatch(requestLogin(credentials)),
  registerAccount: credentials => dispatch(registerAccount(credentials)),
  clearServerError: () => dispatch(clearError()),
  closeAuthModal: () => dispatch(closeAuthModal()),
  closeNestedModal: () => dispatch(closeModal()),
  openSignUpModal: () => dispatch(openSignUpModal()),
  openLoginModal: () => dispatch(openLoginModal()),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapActionToProps
  )(LoginModal)
);



// WEBPACK FOOTER //
// ./src/redux/containers/LoginContainer.js